import React, { useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { useDebounce } from '../../hooks/useDebounce.js';

function TitleFilter({ title, navigateAction }) {
  const [value, setValue] = useState(null);

  const debouncedValue = useDebounce(value, 500);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    !title ? setValue('') : setValue(title);
    // clear value after filter reset
  }, [title]);

  useEffect(() => {
    value !== null && (title = value);

    navigateAction({ title });
  }, [debouncedValue]);

  return (
    <div className="report-filter">
      <div className="text-muted filter-label">Change Impact Title</div>
      <FormControl
        placeholder="Enter Title"
        type="text"
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default TitleFilter;
